import { EditBase, Form, useNotify, useRedirect, useTranslate } from "ra-core";
import { SaveButton } from "@/components/admin/form";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

import { fullScreenOnMobile } from "../layout/mobileDialog";
import { SponsoringInputs } from "./SponsoringInputs";

/** Edit dialog, opened on `${basePath}/:id` on top of the list */
export const SponsoringEdit = ({
  open,
  id,
  basePath = "/sponsorings",
}: {
  open: boolean;
  id?: string;
  /** The overview this dialog belongs to (/sponsorings, /balsponsoren, /leads) */
  basePath?: string;
}) => {
  const redirect = useRedirect();
  const notify = useNotify();
  const translate = useTranslate();

  const goToShow = () =>
    redirect(`${basePath}/${id}/show`, undefined, undefined, undefined, {
      _scrollToTop: false,
    });
  const handleClose = () =>
    redirect(basePath, undefined, undefined, undefined, {
      _scrollToTop: false,
    });

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && handleClose()}>
      <DialogContent
        className={`lg:max-w-2xl overflow-y-auto max-h-9/10 top-1/20 translate-y-0 ${fullScreenOnMobile}`}
        aria-describedby={undefined}
      >
        <DialogTitle>
          {translate("resources.sponsorings.action.edit")}
        </DialogTitle>
        {id ? (
          <EditBase
            id={id}
            mutationMode="pessimistic"
            redirect={false}
            mutationOptions={{
              onSuccess: () => {
                notify("resources.sponsorings.updated", { type: "info" });
                goToShow();
              },
            }}
          >
            <Form>
              <SponsoringInputs />
              <div className="flex justify-end gap-2 pt-4">
                <Button type="button" variant="ghost" onClick={goToShow}>
                  {translate("ra.action.cancel")}
                </Button>
                <SaveButton />
              </div>
            </Form>
          </EditBase>
        ) : null}
      </DialogContent>
    </Dialog>
  );
};
